import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

// Actions
export const SET_IS_MOBILE = 'DEVICE/SET_IS_MOBILE';
export const SET_IS_NOT_MOBILE = 'DEVICE/SET_IS_NOT_MOBILE';

// Action Creators
export const setIsMobile = () => ({
  type: SET_IS_MOBILE,
});

export const setIsNotMobile = () => ({
  type: SET_IS_NOT_MOBILE,
});

// Selectors
export const getIsMobile = state => state.isMobile;

// Reducers
export const isMobile = handleActions({
  [SET_IS_MOBILE]: () => true,
  [SET_IS_NOT_MOBILE]: () => false,
}, false);

export default combineReducers({
  isMobile,
});
